import { Dropdown, Modal, Col, Row, Space, Typography, message } from "antd";
import InvoicesView from "../components/invoices/InvoicesView";
import { useState } from "react";
import InvoiceView from "../components/invoices/InvoiceView";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getInvoicesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { Invoice } from "../repository/data.default";
import dayjs from "dayjs";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function InvoicesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const [invoicesInputMode, setInvoicesInputMode] = useState<
    "add" | "update" | "view" | "delete"
  >("add");
  const [invoicesInputUid, setInvoicesInputUid] = useState<
    string | null | undefined
  >(undefined);
  const [invoicesInputOpen, setInvoicesInputOpen] = useState(false);

  const [invoicesInputValues, setInvoicesInputValues] = useState<Invoice>(
    {} as any,
  );
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onInvoiceAction(
    mode: "add" | "update" | "view" | "delete",
    values?: Invoice,
  ): void {
    setInvoicesInputValues(
      values
        ? {
            uid: values.uid,
            rowVersion: values.rowVersion,
            company: {
              display: values.companyName,
              value: values.companyUid,
            },
            description: values.description,
            dueDate: dayjs(values.dueDate),
            totalAmount: values.totalAmount,
            isPaid: values.isPaid,
          }
        : ({} as any),
    );
    setInvoicesInputUid(values?.uid);
    setInvoicesInputMode(mode);
    setInvoicesInputOpen(true);
  }

  function onInvoiceFinish(): void {
    setInvoicesInputOpen(false);
    setInvoicesInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onInvoiceClose(): void {
    setInvoicesInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading Invoices export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getInvoicesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Invoices
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("Invoices", "create")}

            className={`${!permissions.can("Invoices", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("Invoices", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onInvoiceAction("add")}
          >
            Add Invoice
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <InvoicesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onInvoiceAction(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <InvoiceView
        open={invoicesInputOpen}
        mode={invoicesInputMode}
        uid={invoicesInputUid!}
        initialValues={invoicesInputValues}
        onFinish={onInvoiceFinish}
        onClose={onInvoiceClose}
      />
      {contextHolder}
    </Col>
  );
}

export default InvoicesPage;
